module.exports = __webpack_public_path__ + "static/img/Jake-Lever.8853c43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake-Lever.jpg
// module id = iBf+
// module chunks = 0